<template>
  <div>
    <form @submit.prevent="createProducto" class="mx-auto mt-16 max-w-xl sm:mt-20" style="width: 60%;">
      <label for="name" class="mx-auto mt-16 max-w-xl sm:mt-20">Name</label>
      <input type="text" v-model="producto.name" id="name" class="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600" style="border: 1px solid black;" required/>

      <label for="link" class="mx-auto mt-16 max-w-xl sm:mt-20">Link</label>
      <input type="text" v-model="producto.link" id="link" class="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600" style="border: 1px solid black;" required/>

      <label for="brandName" class="mx-auto mt-16 max-w-xl sm:mt-20">Brandname</label>
      <input type="text" v-model="producto.brandName" id="brandName" class="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600" style="border: 1px solid black;" required/>

      <label for="ean" class="mx-auto mt-16 max-w-xl sm:mt-20">Ean</label>
      <input type="text" v-model="producto.ean" id="ean" class="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600" style="border: 1px solid black;" required/>

      <button type="submit">Crear Producto</button>
    </form>

    <div v-if="productosExistentes.length">
      <h2>Productos existentes:</h2>
      <ul>
        <li v-for="p in productosExistentes" :key="p.ean">
          {{ p.name }} - {{ p.brandName }} - {{ p.ean }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { createProducto } from '@/services/ikno/createProducto'
import { getProductos } from '@/services/ikno/getProducto'

export default {
  data () {
    return {
      producto: {
        name: '',
        link: '',
        brandName: '',
        ean: ''
      },
      productosExistentes: []
    }
  },
  methods: {
    async createProducto () { // <--- espacio agregado antes del paréntesis
      try {
        await createProducto(this.producto)
        alert('Producto creado correctamente')
        this.producto = { name: '', link: '', brandName: '', ean: '' }
        await this.fetchProductos()
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
        alert('Error al crear producto')
      }
    },
    async fetchProductos () { // <--- espacio agregado antes del paréntesis
      try {
        const response = await getProductos()
        this.productosExistentes = response.products || response
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
        alert('Error al obtener productos')
      }
    }
  },
  mounted () { // <--- espacio agregado antes del paréntesis
    this.fetchProductos()
  }
}
</script>
